import React, { useMemo, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { FaCheck, FaExclamationTriangle, FaKey } from 'react-icons/fa';
import { resetPassword } from '../services/auth';
import { InputSimple } from '../components/form/input.Simple';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = useMemo(() => searchParams.get('token') || '', [searchParams]);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async event => {
    event.preventDefault();
    setMessage('');
    setError('');

    if (!token) {
      setError('Lien de réinitialisation invalide.');
      return;
    }
    if (password.length < 6) {
      setError('Le mot de passe doit contenir au moins 6 caractères.');
      return;
    }
    if (password !== confirmPassword) {
      setError('Les deux mots de passe ne correspondent pas.');
      return;
    }

    setLoading(true);
    try {
      await resetPassword({ token, password });
      setPassword('');
      setConfirmPassword('');
      setDone(true);
      setMessage('Mot de passe modifié. Tu peux maintenant te connecter.');
    } catch (err) {
      const code = err?.response?.data?.error;
      if (code === 'invalid_or_expired_token') {
        setError('Ce lien est invalide ou expiré.');
      } else if (code === 'password_too_short') {
        setError('Le mot de passe doit contenir au moins 6 caractères.');
      } else {
        setError('Impossible de modifier le mot de passe.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='flex min-h-screen w-full items-center justify-center bg-primary-d p-1 text-contrast md:p-2'>
      <section className='flex w-full max-w-xl flex-col gap-1 rounded-lg bg-main bg-opacity-40 p-1 shadow-lg md:p-2'>
        <div className='flex items-center gap-1'>
          <div className='flex h-3 w-3 items-center justify-center rounded-full bg-primary text-xl'>
            <FaKey />
          </div>
          <div>
            <p className='text-xs uppercase tracking-widest text-secondary'>
              Ligne et Lore
            </p>
            <h1 className='font-condensed text-3xl font-bold uppercase'>
              Nouveau mot de passe
            </h1>
          </div>
        </div>

        <p className='text-sm text-contrast text-opacity-70'>
          Choisis un nouveau mot de passe pour réactiver la connexion par email.
        </p>

        {done ? (
          <div className='flex flex-col gap-1 rounded bg-primary bg-opacity-25 p-1'>
            <div className='flex items-center gap-05 text-sm text-green'>
              <FaCheck />
              {message}
            </div>
            <Link
              to='/profile'
              className='rounded bg-primary px-1 py-05 text-center text-sm shadow transition hover:bg-secondary'
            >
              Aller à la connexion
            </Link>
          </div>
        ) : (
          <form
            className='flex flex-col gap-05'
            onSubmit={handleSubmit}
          >
            <InputSimple
              type='password'
              placeholder='Nouveau mot de passe'
              forcedValue={password}
              className='m-0 w-full'
              onChange={event => setPassword(event.target.value)}
            />
            <InputSimple
              type='password'
              placeholder='Confirmer le mot de passe'
              forcedValue={confirmPassword}
              className='m-0 w-full'
              onChange={event => setConfirmPassword(event.target.value)}
            />

            {error && (
              <div className='flex items-center gap-05 rounded bg-red bg-opacity-20 p-05 text-sm text-red'>
                <FaExclamationTriangle />
                {error}
              </div>
            )}

            <button
              type='submit'
              disabled={loading}
              className='mt-05 rounded bg-primary px-1 py-05 text-sm shadow transition hover:bg-secondary disabled:opacity-50'
            >
              {loading ? 'Modification...' : 'Modifier le mot de passe'}
            </button>
          </form>
        )}

        <Link
          to='/'
          className='text-sm text-secondary hover:text-primary'
        >
          Retour à l’accueil
        </Link>
      </section>
    </div>
  );
};

export default ResetPassword;
